export default __webpack_public_path__ + "static/media/dash_niyama_care.b77138e5.svg";